module.exports = "//public.zight.com/packs/media/images/icons-mouse-click-cc0553f8473f04f776991b8331e5aad7.svg";